import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { delay, dematerialize, map, mapTo, materialize } from "rxjs/operators";

import { BrugerHttpClient, ParametreForAktuelleInstallation, UmbracoHttpClient } from "@e-forsyning/common/http";

import { FakturaStatus } from "../model/faktura-status.model";
import { FakturaDto } from "../model/faktura.dto";
import { Faktura } from "../model/faktura.model";
import { FakturagodkendelseIndstillingerDto } from "../model/fakturagodkendelse-indstillinger.dto";
import { FakturagodkendelseIndstillinger } from "../model/fakturagodkendelse-indstillinger.model";
import { FakturaMapper } from "./faktura.mapper";

@Injectable({ providedIn: "root" })
export class FakturagodkendelseRepository {
    constructor(
        private readonly http: BrugerHttpClient,
        private readonly umbracoHttp: UmbracoHttpClient,
        private readonly mapper: FakturaMapper
    ) {}

    public hentIndstillinger(): Observable<FakturagodkendelseIndstillinger> {
        return this.umbracoHttp.hentSideData<FakturagodkendelseIndstillingerDto>("fakturagodkendelse").pipe(
            map((dto) => ({
                sideTitel: dto.menuTekst
            }))
        );
    }

    public hentFakturaerTilGodkendelse(): Observable<Faktura[]> {
        return this.http
            .get("api/HentFakturaerTilGodkendelse")
            .pipe(map((data) => data.fakturaliste.map((faktura: FakturaDto) => this.mapper.dtoToFaktura(faktura))));
    }

    public setFakturaStatus(faktura: Faktura, kodeord: string, bemaerkning: string, status: FakturaStatus): Observable<void> {
        const startTime = Date.now();
        return this.http
            .post(
                "api/GemFakturaStatus",
                {
                    dokumentnr: faktura.dokumentnr,
                    kode: kodeord,
                    bemaerkning,
                    status
                },
                ParametreForAktuelleInstallation.false
            )
            .pipe(materialize(), delay(1000 + startTime - Date.now()), dematerialize(), mapTo(null));
    }
}
